export default "__VITE_ASSET__DJwhINGB__"